import React from "react";
import { useTranslation } from "react-i18next";
import { Space, Typography } from "antd";
import Header from "src/components/header";
import styles from "./maintenance.module.scss";

const { Title, Text } = Typography;

const Maintenance: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className={styles.maintenance_container}>
      <Space align="center" className={styles.maintenance_header}>
        <Header />
      </Space>
      <Space direction="vertical" className={styles.maintenance_wrapper}>
        <Title className={styles.maintenance_title}>
          {t("maintenance.title")}
        </Title>
        <Text className={styles.maintenance_description}>
          {t("maintenance.description")}
        </Text>
      </Space>
    </div>
  );
};

export default Maintenance;
